<template>
  <div class="Returnlist">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        退货申请
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="setPage(1)">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="menu">
        <button
          class="btn3 clear-item"
          @click="setType(null)"
          v-bind:class="{ active: resType == null }"
        >
          全部申请(
          <i>{{count0}}</i>
          )
        </button>
        <button class="btn3 clear-item" @click="setType(1)" v-bind:class="{ active: resType == 1}">
          待处理(
          <i>{{count1}}</i>
          )
        </button>
        <button class="btn3 clear-item" @click="setType(2)" v-bind:class="{ active: resType == 2 }">
          退货中(
          <i>{{count2}}</i>
          )
        </button>
        <button class="btn3 clear-item" @click="setType(4)" v-bind:class="{ active: resType == 4 }">
          已完成(
          <i>{{count3}}</i>
          )
        </button>
        <button class="btn3 clear-item" @click="setType(3)" v-bind:class="{ active: resType == 3 }">
          已拒绝(
          <i>{{count4}}</i>
          )
        </button>
      </div>

      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">筛选查询</div>
      </div>
      <div style="background-color:#fff;margin-bottom: 20px;">
        <el-row class="search" :gutter="10">
          <el-col :span="2">
            <div class="label">输入搜索:</div>
          </el-col>
          <el-col :span="4">
            <el-input clearable v-model="orderCode" size="small" placeholder="服务单号"></el-input>
          </el-col>
          <el-col :span="2">
            <div class="label">收货人:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="mobile" clearable size="small" placeholder="用户账户"></el-input>
          </el-col>
          <el-col :span="2">
            <div class="label">申请状态:</div>
          </el-col>
          <el-col :span="4">
            <template>
              <el-select clearable v-model="value" size="small" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </el-col>
          <el-col :span="6" align="center">
            <div class="filtrate_seek_sousuo" @click="geting1()">搜索</div>
          </el-col>
        </el-row>
      </div>

      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table :data="tableData" border style="width: 100%" ref="multipleTable">
        <el-table-column prop="code" width="200" label="服务单号" align="center"></el-table-column>

        <el-table-column prop="create_date" width="160" label="申请时间" align="center"></el-table-column>
        <el-table-column prop="mobile" label="用户账户" align="center"></el-table-column>
        <el-table-column prop="return_money" label="退款金额" align="center"></el-table-column>
        <el-table-column prop="status" label="申请状态" align="center"></el-table-column>

        <el-table-column label="操作" width="200" align="center" name="bianji">
          <template slot-scope="scope" style="display:flex;padding:0;margin:0">
            <button @click="red(scope.row.return_id)" class="button1">查看订单</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page_box clearfix">
        <div class="page">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="15"
            :current-page.sync="page"
            @current-change="setPage"
          ></el-pagination>
        </div>
      </div>
    </div>
    <noAccess v-else></noAccess>
  </div>
</template>

<script>
import "../assets/all.css";
export default {
  name: "list",
  data() {
    return {
      serve: this.$store.state.serve,
      role: true,
      options: [
        {
          value: "1",
          label: "待处理"
        },
        {
          value: "2",
          label: "退货中"
        },
        {
          value: "4",
          label: "已完成"
        },
        {
          value: "3",
          label: "已拒绝"
        }
      ],
      token: "",
      username: "",
      value: "",
      tableData: [],
      count0: 0, //全部申请
      count1: 0, //待处理
      count2: 0, //退货中
      count3: 0, //以完成
      count4: 0, //已拒绝
      page: null,
      total: 0,
      orderCode: "",
      mobile: "",
      status: "",
      resType: null,
      id: "",
      number: "",
      name: "",
      value1: "",
      name: null,
      category: null,
      categorys: [],
      brand: null,
      brands: [],
      multipleSelection: [],
      isIndeterminate: true,
      select: false,
      selectAll: false,
      checked: [],
      idString: ""
    };
  },
  created() {
    this.$store.state.leftTitle = "退货申请";
    this.$store.state.topActiveId = 3;
    this.geting();
  },
  watch: {
    //监听全选状态
    selectAll(v) {
      if (v == false) {
        this.$refs.multipleTable.clearSelection();
      } else {
        this.$refs.multipleTable.clearSelection();
        this.$refs.multipleTable.toggleAllSelection();
      }
    }
  },
  methods: {
    red(id) {
      this.$router.push({
        path: "d_returnDetail/" + id
      });
    },
    setType(type) {
      //点击分类 订单
      this.resType = type;
      this.geting();
    },

    setPage(v) {
      //分页

      this.page = v;
      this.geting(v);
      this.selectAll = false;
    },

    geting(page) {
      //请求数据
      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/return_product", {
          params: {
            token: this.token,
            username: this.username,
            orderCode: this.orderCode,
            mobile: this.mobile,
            status: this.value,
            page: page,
            status: this.resType
          }
        })
        .then(res => {
          that.tableData = [];
          if (res.data.status == "success") {
            var json = res.data.data;
            if (json) {
              that.page = json.now_page;
              that.total = json.total;
              for (var key in json.results) {
                var time = json.results[key].create_date;
                var timeNew = new Date(parseInt(time) * 1000)
                  .toLocaleString()
                  .replace(/:\d{1,2}$/, " ");
                json.results[key].create_date = timeNew;
                that.tableData.push(json.results[key]);
                if (json.results[key].status == "1") {
                  json.results[key].status = "待处理";
                }
                if (json.results[key].status == "2") {
                  json.results[key].status = "退货中";
                }
                if (json.results[key].status == "3") {
                  json.results[key].status = "已拒绝";
                }
                if (json.results[key].status == "4") {
                  json.results[key].status = "已完成";
                }
              }
            }
            this.count0 = json.num;
            this.count1 = json.num1;
            this.count2 = json.num2;
            this.count3 = json.num4;
            this.count4 = json.num3;
          }else{
            if(res.data.msg == "无权访问")
            {
              this.role = false
            }
          }
        });
    },
    geting1(page) {
      //搜索
      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/return_product", {
          params: {
            token: this.token,
            username: this.username,
            orderCode: this.orderCode,
            mobile: this.mobile,
            status: this.value,
            page: page
          }
        })
        .then(res => {
          that.tableData = [];
          if (res.data.status == "success") {
            var json = res.data.data;
            if (json) {
              that.page = json.now_page;
              that.total = json.total;
              for (var key in json.results) {
                that.tableData.push(json.results[key]);
                if (json.results[key].status == "1") {
                  json.results[key].status = "待处理";
                }
                if (json.results[key].status == "2") {
                  json.results[key].status = "退货中";
                }
                if (json.results[key].status == "3") {
                  json.results[key].status = "已拒绝";
                }
                if (json.results[key].status == "4") {
                  json.results[key].status = "已完成";
                }
              }
            }
            this.count0 = json.num;
            this.count1 = json.num1;
            this.count2 = json.num2;
            this.count3 = json.num4;
            this.count4 = json.num3;
          } else {
            if (res.data.msg == "无权访问") {
              this.role = false;
            }
          }
        });
    }
  }
};
</script>
<style lang="scss">
.Returnlist {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: left;
    margin-bottom: 20px;
    .btn3 {
      margin-right: 40px;
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
    .active i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>